import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../common/loader/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (request: any, next) => {
    const loaderService = inject(LoaderService);
    loaderService.show();
   
    return next(request).pipe(
        finalize(() => loaderService.hide()));
};